"use strict";
/*!
 *
 *  Local.ts
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var default_1 = /** @class */ (function () {
    function default_1() {
        if ($('.st-Main').is('.-has-local')) {
            this.$parent = $('#HeaderFollow');
            this.label = $('.c-PageTitle_EN').text();
            this.$target = $('.st-Main_Inner h2').filter(function (i, elem) {
                return !$(elem).data('local-disabled');
            });
            this.$parent.append("\n\t\t\t\t<div :class=\"{'st-Local': true, '-visible': visible}\" id=\"Local\" v-load=\"setPosition\" v-resize=\"setPosition\" v-scroll=\"handleScroll\">\n\t\t\t\t\t<local-menu :label=\"label\" :targets=\"targets\" />\n\t\t\t\t</div>\n\t\t\t");
            this.setTarget();
            this.targetArr = this.getTarget();
            this.setLocal();
        }
        ;
    }
    default_1.prototype.setTarget = function () {
        this.$target.each(function (i, elem) {
            if (!$(elem).attr('id')) {
                $(elem).attr('id', 'target-' + Date.now() + '-' + i);
            }
            ;
        });
    };
    default_1.prototype.getTarget = function () {
        var arr = [];
        this.$target.each(function (i, elem) {
            var label = '';
            if ($(elem).data('short')) {
                label = $(elem).data('short');
            }
            else {
                label = $(elem).text().replace(/\t|\n|\r/g, '').replace(/^ +/, '');
                if ($('html').attr('lang') === 'ja') {
                    var en = $(elem).children('.en').text().replace(/\t|\n|\r/g, '');
                    label = label.replace(en, '').replace(/^ +/, '');
                }
                ;
            }
            ;
            arr.push({
                id: $(elem).attr('id'),
                label: label,
                top: $(elem).offset().top,
                current: false
            });
        });
        return arr;
    };
    default_1.prototype.setLocal = function () {
        var self = this;
        vue_1.default.directive('scroll', {
            inserted: function (el, binding) {
                var f = function (evt) {
                    if (binding.value(evt, el)) {
                        window.removeEventListener('scroll', f);
                    }
                };
                window.addEventListener('scroll', f);
            }
        });
        vue_1.default.directive('resize', {
            inserted: function (el, binding) {
                var f = function (evt) {
                    if (binding.value(evt, el)) {
                        window.removeEventListener('resize', f);
                    }
                };
                window.addEventListener('resize', f);
            }
        });
        vue_1.default.directive('load', {
            inserted: function (el, binding) {
                var f = function (evt) {
                    if (binding.value(evt, el)) {
                        window.removeEventListener('load', f);
                    }
                };
                window.addEventListener('load', f);
            }
        });
        vue_1.default.component('local-menu', {
            props: ['label', 'targets'],
            data: function () {
                return {
                    expanded: false
                };
            },
            template: "\n\t\t\t\t<div class=\"st-Local_Inner\" v-resize=\"check\">\n\t\t\t\t\t<div @click.prevent=\"expand\" :class=\"{'st-Local_Label': true, '-expanded': expanded}\">{{ label }}</div>\n\t\t\t\t\t<transition v-on:enter=\"enter\" v-on:after-enter=\"afterEnter\" v-on:leave=\"leave\" v-on:after-leave=\"afterLeave\">\n\t\t\t\t\t\t<div class=\"st-Local_List\" v-show=\"expanded\">\n\t\t\t\t\t\t\t<div class=\"st-Local_List_Inner\">\n\t\t\t\t\t\t\t\t<div :class=\"{'st-Local_Item': true, '-current': item.current}\" v-for=\"item in targets\" :key=\"item.id\">\n\t\t\t\t\t\t\t\t\t<a :href=\"'#' + item.id\" @click.prevent=\"close\">{{ item.label }}</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</transition>\n\t\t\t\t</div>\n\t\t\t",
            mounted: function () {
                var _this = this;
                this.check();
                window.addEventListener('click', function (e) {
                    if (!$(e.target).closest('.st-Local').length) {
                        _this.close();
                    }
                    ;
                });
            },
            methods: {
                check: function () {
                    if (util.viewport !== 'tablet' && util.viewport !== 'phone') {
                        this.expanded = true;
                    }
                    else {
                        this.expanded = false;
                    }
                    ;
                },
                expand: function () {
                    this.expanded = this.expanded ? false : true;
                },
                close: function () {
                    if (util.viewport === 'tablet' || util.viewport === 'phone') {
                        this.expanded = false;
                    }
                    ;
                },
                enter: function (element) {
                    var elementHeight = element.getBoundingClientRect().height;
                    element.style.height = '0px';
                    element.offsetHeight;
                    element.style.height = elementHeight + 'px';
                },
                afterEnter: function (element) {
                    element.style.height = null;
                },
                leave: function (element) {
                    var elementHeight = element.getBoundingClientRect().height;
                    element.style.height = elementHeight + 'px';
                    element.offsetHeight;
                    element.style.height = '0px';
                },
                afterLeave: function (element) {
                    element.style.height = null;
                }
            }
        });
        var getPos = function () {
            return $('[data-local-visible="true"]').length > 0 ? $('[data-local-visible="true"]').offset().top + $('[data-local-visible="true"]').height() : $('.st-Main_Inner').offset().top;
        };
        new vue_1.default({
            el: '#Local',
            data: {
                label: self.label,
                targets: self.targetArr,
                visible: false,
                visiblePos: getPos()
            },
            mounted: function () {
                this.visiblePos = getPos();
            },
            methods: {
                handleScroll: function (e, el) {
                    var _this = this;
                    if (!this.visible && this.visiblePos < window.pageYOffset) {
                        this.visible = true;
                    }
                    ;
                    if (this.visible && this.visiblePos >= window.pageYOffset) {
                        this.visible = false;
                    }
                    ;
                    var y = window.pageYOffset + (window.innerHeight / 2);
                    this.targets = this.targets.map(function (val, i) {
                        if (y > val.top && y <= (_this.targets[i + 1] ? _this.targets[i + 1].top : $('#Footer').offset().top)) {
                            val.current = true;
                        }
                        else {
                            val.current = false;
                        }
                        ;
                        return val;
                    });
                    if (this.visible && y > $('#Footer').offset().top) {
                        this.visible = false;
                    }
                    ;
                },
                setPosition: function (e, el) {
                    this.visiblePos = getPos();
                    this.targets = this.targets.map(function (val, i) {
                        val.top = $('#' + val.id).offset().top;
                        return val;
                    });
                }
            }
        });
    };
    return default_1;
}());
exports.default = default_1;
;
